const WatcherDashboard = () => {
	return <div>WatcherDashboard</div>;
};

export default WatcherDashboard;
